import { render, staticRenderFns } from "./AnthropometricEvaluation.vue?vue&type=template&id=fc50204c&scoped=true&"
import script from "./AnthropometricEvaluation.vue?vue&type=script&lang=js&"
export * from "./AnthropometricEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./AnthropometricEvaluation.vue?vue&type=style&index=0&id=fc50204c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc50204c",
  null
  
)

export default component.exports